/** Route paths for the analysis protocol correction module. */
export const analysisProtocolCorrectionRoutePaths = {
    overview: '/analysis-protocol-correction',
    newReport: '/analysis-protocol-correction/new',
    reportDetail: '/analysis-protocol-correction/:id',
};
